'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = exports.propTypes = {
  bottom: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  left: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  position: _propTypes2.default.string,
  right: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  top: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};
var propAliases = exports.propAliases = {};
var propValidators = exports.propValidators = {};
var _position = {
  className: 'pst',
  cssName: 'position',
  jsName: 'position',
  safeValue: true,
  isPrefixed: true
};
var _top = {
  className: 'top',
  cssName: 'top',
  jsName: 'top'
};
var _right = {
  className: 'rgt',
  cssName: 'right',
  jsName: 'right'
};
var _bottom = {
  className: 'btm',
  cssName: 'bottom',
  jsName: 'bottom'
};
var _left = {
  className: 'lft',
  cssName: 'left',
  jsName: 'left'
};
var propEnhancers = exports.propEnhancers = {
  bottom: function bottom(value) {
    return (0, _getCss2.default)(_bottom, value);
  },
  left: function left(value) {
    return (0, _getCss2.default)(_left, value);
  },
  position: function position(value) {
    return (0, _getCss2.default)(_position, value);
  },
  right: function right(value) {
    return (0, _getCss2.default)(_right, value);
  },
  top: function top(value) {
    return (0, _getCss2.default)(_top, value);
  }
};